export default __webpack_public_path__ + "static/media/magnifying-glass.493eaf37.png";